// Kept in sync with apps/subscription-flow-liability-de (the standalone liability flow).
export const DANGEROUS_BREEDS = [
  "american_bully",
  "american-staffordshire-terrier",
  "berger_du_caucase",
  "boerbull",
  "bull_terrier",
  "bullmastiff",
  "ca_de_bou",
  "cane_corso",
  "doberman",
  "dogo_canario",
  "dogue_allemand",
  "dogue_argentin",
  "dogue_de_bordeaux",
  "dogue_du_tibet",
  "fila_brasileiro",
  "fila_de_sao_miguel",
  "mastiff",
  "matin_de_naples",
  "matin_des_pyrenees",
  "matin_espagnol",
  "montagne_des_pyrenees",
  "old_english_bouledogue",
  "pitbull",
  "rhodesian-ridgeback",
  "rottweiler",
  "staffordshire_bull_terrier",
  "tosa",
] as const

export const isDangerousBreed = (breed?: string | null) =>
  breed != null && DANGEROUS_BREEDS.includes(breed as any)
